// AUTO-GENERATED PALETTE BRIDGE (initial manual version)
// In a later step this file can be generated from JSON tokens.

import colorPrimitives from '../tokens/color.primitives.json';

type ShadeKey = '50' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';

type ColorScale = Record<ShadeKey | '10', string>;

function scale(name: keyof typeof colorPrimitives.color): ColorScale {
  const raw = (colorPrimitives as any).color[name] || {};
  return {
    '10': raw['10']?.value,
    '50': raw['50']?.value,
    '100': raw['100']?.value,
    '200': raw['200']?.value,
    '300': raw['300']?.value,
    '400': raw['400']?.value,
    '500': raw['500']?.value,
    '600': raw['600']?.value,
    '700': raw['700']?.value,
    '800': raw['800']?.value,
    '900': raw['900']?.value,
  } as ColorScale;
}

const semanticError = scale('semantic').error;

export const PrimaryColor = {
  main: scale('primary')['900'],
  light: scale('primary')['900'],
  dark: scale('primary')['900'],
  contrastText: scale('primary')['50'],
};

export const SecondaryColor = {
  main: scale('secondary')['500'],
  light: scale('secondary')['200'],
  dark: scale('secondary')['900'],
  contrastText: scale('secondary')['50'],
};

export const SemanticErrorColor = {
  main: (colorPrimitives as any).color.semantic.error['500'].value,
  light: (colorPrimitives as any).color.semantic.error['100'].value,
  dark: (colorPrimitives as any).color.semantic.error['900'].value,
  contrastText: (colorPrimitives as any).color.semantic.error['50'].value,
};

export const SemanticSuccessColor = {
  main: (colorPrimitives as any).color.semantic.success['500'].value,
  light: (colorPrimitives as any).color.semantic.success['100'].value,
  dark: (colorPrimitives as any).color.semantic.success['900'].value,
  contrastText: (colorPrimitives as any).color.semantic.success['50'].value,
};

export const SemanticWarningColor = {
  main: (colorPrimitives as any).color.semantic.warningCore['500'].value,
  light: (colorPrimitives as any).color.semantic.warningCore['100'].value,
  dark: (colorPrimitives as any).color.semantic.warningCore['900'].value,
  contrastText: (colorPrimitives as any).color.semantic.warningCore['50'].value,
};

export const SemanticInfoColor = {
  main: (colorPrimitives as any).color.semantic.info['500'].value,
  light: (colorPrimitives as any).color.semantic.info['100'].value,
  dark: (colorPrimitives as any).color.semantic.info['900'].value,
  contrastText: (colorPrimitives as any).color.semantic.info['50'].value,
};

export const GreenHighlightColor = {
  main: scale('greenHighlight')['500'],
  light: scale('greenHighlight')['200'],
  dark: scale('greenHighlight')['900'],
  contrastText: scale('greenHighlight')['50'],
};

export const PremiumColor = {
  main: scale('premium')['700'],
  light: scale('premium')['200'],
  dark: scale('premium')['900'],
  contrastText: scale('premium')['50'],
};

export const SludgeColor = {
  main: scale('sludge')['700'],
  light: scale('sludge')['200'],
  dark: scale('sludge')['900'],
  contrastText: scale('sludge')['50'],
};

export const ButterCupColor = {
  main: scale('butterCup')['500'],
  light: scale('butterCup')['200'],
  dark: scale('butterCup')['900'],
  contrastText: scale('butterCup')['50'],
};

export const ChristineColor = {
  main: scale('christine')['500'],
  light: scale('christine')['200'],
  dark: scale('christine')['900'],
  contrastText: scale('christine')['50'],
};

export const GreenyColor = {
  main: scale('greeny')['500'],
  light: scale('greeny')['200'],
  dark: scale('greeny')['900'],
  contrastText: scale('greeny')['50'],
};

export const HibiscusColor = {
  main: scale('hibiscus')['500'],
  light: scale('hibiscus')['200'],
  dark: scale('hibiscus')['900'],
  contrastText: scale('hibiscus')['50'],
};

export const PremiumAddUpColor = {
  main: scale('premiumAddUp')['500'],
  light: scale('premiumAddUp')['200'],
  dark: scale('premiumAddUp')['900'],
  contrastText: scale('premiumAddUp')['50'],
};

export const SmithAppleColor = {
  main: scale('smithApple')['500'],
  light: scale('smithApple')['200'],
  dark: scale('smithApple')['900'],
  contrastText: scale('smithApple')['50'],
};

export const NeutralsColor = {
  50: (colorPrimitives as any).color.neutral['50'].value,
  100: (colorPrimitives as any).color.neutral['100'].value,
  200: (colorPrimitives as any).color.neutral['200'].value,
  300: (colorPrimitives as any).color.neutral['300'].value,
  400: (colorPrimitives as any).color.neutral['400'].value,
  500: (colorPrimitives as any).color.neutral['500'].value,
  600: (colorPrimitives as any).color.neutral['600'].value,
  700: (colorPrimitives as any).color.neutral['700'].value,
  800: (colorPrimitives as any).color.neutral['800'].value,
  900: (colorPrimitives as any).color.neutral['900'].value,
};

